// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__5a9H8","errorCode":"NotFound_errorCode__wsi9x","message":"NotFound_message__xMyqK","homeLink":"NotFound_homeLink__pWkk8"};